import type { Persona } from '@/types/auth.types';

/** Route path constants — single source of truth for all URL paths */
export const ROUTES = {
  ROOT: '/' as const,
  HOME: '/home' as const,
  BOOKINGS: '/bookings' as const,
  BOOKINGS_NEW: '/bookings/new' as const,
  EVENT_VIEW: '/events/:eventId' as const,
  EVENT_CANCEL: '/events/:eventId/cancel' as const,
  ADMIN: '/admin' as const,
  PLANNER: '/planner' as const,
  PLANNER_CALENDAR_VIEW: '/planner/calendar-view' as const,
  PLANNER_EVENT_LIST: '/planner/event-list' as const,
  PLANNER_METRICS_REPORT: '/planner/metrics-report' as const,
  REPORTS: '/reports' as const,
  REPORTS_REPORT_SUMMARY: '/reports/report-summary' as const,
  REPORTS_VOLUME_ACTUAL: '/reports/volume-actual' as const,
  REPORTS_BUILDING_TRENDS: '/reports/building-trends' as const,
  REPORTS_ATTRIBUTES: '/reports/attributes' as const,
  REPORTS_CSATS: '/reports/csats' as const,
  CALENDAR: '/calendar' as const,
  DEMO: '/demo' as const,
} as const;

/** Union type of all valid route paths */
export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

/** Navigation item definition for rendering nav links */
export interface NavItem {
  /** Route path from ROUTES constant */
  path: RoutePath;
  /** i18n translation key for the link label (namespace: common) */
  labelKey: string;
  /** If set, only these personas see/access this nav item. If omitted, all personas can access. */
  allowedPersonas?: readonly Persona[];
}

/** Navigation items configuration — order determines render order in header */
export const NAV_ITEMS: NavItem[] = [
  {
    path: ROUTES.HOME,
    labelKey: 'navigation.home',
    allowedPersonas: ['Admin', 'Planner', 'Employee'],
  },
  {
    path: ROUTES.BOOKINGS,
    labelKey: 'navigation.bookings',
    allowedPersonas: ['Admin', 'Planner', 'Employee'],
  },
  { path: ROUTES.ADMIN, labelKey: 'navigation.admin', allowedPersonas: ['Admin'] },
  { path: ROUTES.PLANNER, labelKey: 'navigation.planner', allowedPersonas: ['Admin', 'Planner'] },
  {
    path: ROUTES.PLANNER_METRICS_REPORT,
    labelKey: 'navigation.metricsReport',
    allowedPersonas: ['Admin', 'Planner'],
  },
  { path: ROUTES.CALENDAR, labelKey: 'navigation.calendar' },
];
